import { Box, Flex, Image, Text } from "@chakra-ui/react"

import arrowDown from "#/assets/arrow-down.svg"
import circleCheck from "#/assets/circle-check-gray.svg"
import {
  DepositActionStatus,
  selectWithdrawalStep,
  useDappSelector,
  WithdrawalSteps,
} from "#/redux-state"
import TransactionProgressLoader from "#/shared/components/TransactionProgressLoader"
import TransactionRejected from "#/shared/components/TransactionRejected"

const withdrawalText: Record<DepositActionStatus, string> = {
  completed: "",
  error: "",
  idle: "",
  "in-progress": "Building transaction... this might take 1-2 minutes",
  processing: "Processing...",
}

const getColorForStep = (
  currentStep: WithdrawalSteps,
  index: WithdrawalSteps,
  status: DepositActionStatus,
) => {
  if (currentStep === index) {
    return status === "error" ? "primary.red.100" : "primary.black.100"
  }

  return "primary.black.50"
}

export default function WithdrawalStatus({
  withdrawalStatus,
  onClick,
}: {
  withdrawalStatus: DepositActionStatus
  onClick: () => void
}) {
  const withdrawalStep = useDappSelector(selectWithdrawalStep)

  if (withdrawalStatus === "idle") return null

  return (
    <Box bg="primary.black.5" rounded="16px">
      <Flex alignItems="center" gap={4}>
        <Image src={arrowDown} />
        <Box>
          <Flex
            gap={withdrawalStep === "withdraw" ? "25px" : "45px"}
            mb={2}
            fontWeight={700}
            fontFamily="riforma.bold"
            letterSpacing="0.16px"
          >
            <Flex gap={1} alignItems="center">
              <Text
                color={getColorForStep(
                  withdrawalStep,
                  "retrieve",
                  withdrawalStatus,
                )}
              >
                1. Claim BTC
              </Text>
              {withdrawalStep === "withdraw" && <Image src={circleCheck} />}
            </Flex>
            <Text
              color={getColorForStep(
                withdrawalStep,
                "withdraw",
                withdrawalStatus,
              )}
            >
              2. Withdraw BTC
            </Text>
          </Flex>
          {withdrawalStatus === "error" ? (
            <TransactionRejected onClick={onClick} />
          ) : (
            <TransactionProgressLoader
              size="16px"
              gap={1}
              textVariant="body"
              color="green.highlight"
              text={withdrawalText[withdrawalStatus]}
            />
          )}
        </Box>
      </Flex>
    </Box>
  )
}
